// extracted by mini-css-extract-plugin
export var reportMenuButton = "admin-panel-module--report-menu-button--pSUS5";
export var reportMenuButtonActive = "admin-panel-module--report-menu-button-active--+Z1+Z";
export var reportsContent = "admin-panel-module--reports-content--XPRO1";
export var reportsLayout = "admin-panel-module--reports-layout--7jESE";
export var reportsMenu = "admin-panel-module--reports-menu--9MkHe";
export var reportsSection = "admin-panel-module--reports-section--HXCWS";